export default "__VITE_ASSET__BUC1dXks__"